<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :customClass="'purchase-order-create'"
    header-left-class="purchase-order-heading-left"
    header-right-class="purchase-order-button-right"
    v-if="
      purchaseOrderId > 0
        ? getPermission('purchase-order:update')
        : getPermission('purchase-order:create')
    "
  >
    <template v-slot:header-title>
      <div class="d-flex justify-space-between">
        <h1 class="form-title text-truncate d-flex align-baseline">
          PO for

          <div
            v-if="!lodash.isEmpty(customer)"
            class="ml-3 form-title-link text-h5 color-custom-blue font-weight-700"
            :class="{ 'cursor-pointer': purchaseOrderId <= 0 }"
            @click="purchaseOrderId <= 0 && refDialogOpen()"
          >
            {{ customer.display_name }}
          </div>
          <template v-else-if="!lodash.isEmpty(purchaseOrderCreate.supplier)">
            <div
              class="ml-3 form-title-link cursor-pointer text-h5 color-custom-blue font-weight-700"
              v-on:click="refDialogOpen"
            >
              {{
                purchaseOrderCreate.supplier.display_name ||
                purchaseOrderCreate.supplier.full_name
              }}
            </div>
          </template>
          <template v-else>
            <div
              class="ml-3 form-title-link cursor-pointer text-h5 color-custom-blue font-weight-600"
              v-on:click="refDialogOpen"
            >
              Select a Supplier
              <v-icon large color="cyan">mdi-account-check-outline</v-icon>
            </div>
            <!-- <div class="mx-3 text-muted font-weight-500">OR</div>
            <div
              class="form-title-link cursor-pointer cyan--text text--darken-4 text-h5 font-weight-600"
              v-on:click="createSupplierDialog()"
            >
              Create a new Supplier
              <v-icon large color="cyan darken-4"
                >mdi-plus-circle-outline</v-icon
              >
            </div> -->
          </template>
        </h1>
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mr-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          {{ purchaseOrderCreate.barcode }}
        </v-chip>
      </div>
    </template>
    <template v-slot:header-action>
      <v-btn
        depressed
        v-on:click="goBack"
        :disabled="formLoading || pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        depressed
        :disabled="
          !isPurchaseOrderActionEnabled ||
          isPurchaseOrderApproved ||
          formLoading ||
          pageLoading ||
          invalidLineItemAllocation
        "
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        v-on:click="updateOrCreate('')"
        color="cyan"
      >
        {{ purchaseOrderId > 0 ? "Update" : "Save" }}
      </v-btn>
      <!-- <template v-if="getPermission('purchase-order:approve')">
        <v-btn
          depressed
          :disabled="
            !isPurchaseOrderActionEnabled ||
            isPurchaseOrderApproved ||
            formLoading ||
            pageLoading
          "
          :loading="formLoading"
          class="mx-2 custom-bold-button white--text"
          v-on:click="updateOrCreate('approve')"
          color="cyan"
        >
          {{ purchaseOrderId > 0 ? "Update and Approve" : "Save and Approve" }}
        </v-btn>
      </template> -->
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="height: calc(100vh - 150px); position: relative"
      >
        <v-form
          ref="purchaseOrderForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateOrCreate('')"
        >
          <v-container fluid class="pt-0">
            <v-row>
              <v-col md="6">
                <v-row class="pa-1">
                  <v-col md="12" class="pb-2">
                    <div class="min-width-per-49">
                      <label
                        class="required font-size-14 font-weight-600 color-custom-blue"
                        >Title</label
                      >
                      <TextField
                        dense
                        filled
                        placeholder="Title"
                        solo
                        flat
                        counter="50"
                        v-model="purchaseOrderCreate.title"
                        color="cyan"
                        :maxlength="50"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        :rules="[
                          validateRules.required(
                            purchaseOrderCreate.title,
                            'Title'
                          ),
                        ]"
                      />
                    </div>
                    <TextAreaField
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      :disabled="pageLoading"
                      v-model="purchaseOrderCreate.description"
                      placeholder="Description"
                      solo
                      flat
                      row-height="25"
                      counter="250"
                    />
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-card
                      flat
                      outlined
                      class="rounded-lg bg-slate-50 pa-3 h-100 border-slate"
                    >
                      <div
                        class="d-flex align-center justify-space-between mb-2 pb-2 custom-border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon small color="cyan darken-2" class="mr-2"
                            >mdi-truck-delivery-outline</v-icon
                          >
                          <span
                            class="font-size-14 font-weight-700 color-custom-blue"
                            >Supplier Details</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan darken-2"
                          class="bg-white custom-grey-border"
                          v-on:click="refDialogOpen('supplier')"
                          title="Edit Supplier"
                          v-if="!purchaseOrderId"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                      <template v-if="purchaseOrderCreate.supplier">
                        <div
                          class="d-flex align-center mb-1 font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-account-outline</v-icon
                          >
                          <span
                            class="font-weight-600 text-slate-800"
                            v-if="
                              purchaseOrderCreate.supplier.display_name ||
                              purchaseOrderCreate.supplier.full_name
                            "
                          >
                            {{
                              purchaseOrderCreate.supplier.display_name ||
                              purchaseOrderCreate.supplier.full_name
                            }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No display name available</em
                          >
                        </div>
                        <div
                          class="d-flex align-center mb-1 font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-phone-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            v-if="
                              purchaseOrderCreate.supplier.company_number ||
                              purchaseOrderCreate.supplier.phone
                            "
                          >
                            {{
                              purchaseOrderCreate.supplier.company_number ||
                              purchaseOrderCreate.supplier.phone
                            }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No company number available</em
                          >
                        </div>
                        <div
                          class="d-flex align-center mb-1 font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-email-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            v-if="
                              purchaseOrderCreate.supplier.company_email ||
                              purchaseOrderCreate.supplier.supplier_email
                            "
                          >
                            {{
                              purchaseOrderCreate.supplier.company_email ||
                              purchaseOrderCreate.supplier.supplier_email
                            }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No company email available</em
                          >
                        </div>
                        <div
                          class="d-flex align-center font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-office-building-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            v-if="purchaseOrderCreate.supplier.company_name"
                          >
                            {{ purchaseOrderCreate.supplier.company_name }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No company name available</em
                          >
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex align-center py-2 red--text text--darken-1 font-size-13 font-weight-500"
                        >
                          <v-icon small color="red darken-1" class="mr-1"
                            >mdi-alert-circle-outline</v-icon
                          >
                          Please select Supplier
                        </div>
                      </template>
                    </v-card>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-card
                      flat
                      outlined
                      class="rounded-lg bg-slate-50 pa-3 h-100 border-slate"
                    >
                      <div
                        class="d-flex align-center justify-space-between mb-2 pb-2 custom-border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon small color="cyan darken-2" class="mr-2"
                            >mdi-account-circle-outline</v-icon
                          >
                          <span
                            class="font-size-14 font-weight-700 color-custom-blue"
                            >Contact Persons</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan darken-2"
                          class="bg-white custom-grey-border"
                          v-on:click="supplierPersonDialog = true"
                          title="Edit Contact Person"
                          v-if="!purchaseOrderId"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>

                      <template v-if="activePerson">
                        <div
                          class="d-flex align-center mb-1 font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-account-outline</v-icon
                          >
                          <span class="font-weight-600 text-slate-800">{{
                            activePerson.display_name
                          }}</span>
                        </div>
                        <div
                          class="d-flex align-center mb-1 font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-phone-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            v-if="activePerson.primary_phone"
                          >
                            {{ activePerson.primary_phone }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No phone number available</em
                          >
                        </div>
                        <div
                          class="d-flex align-center font-size-13 custom-nowrap-ellipsis"
                        >
                          <v-icon small color="slate-500" class="mr-2"
                            >mdi-email-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            v-if="activePerson.primary_email"
                          >
                            {{ activePerson.primary_email }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No email available</em
                          >
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex align-center py-2 red--text text--darken-1 font-size-13 font-weight-500"
                        >
                          <v-icon small color="red darken-1" class="mr-1"
                            >mdi-alert-circle-outline</v-icon
                          >
                          Please select Supplier
                        </div>
                      </template>
                    </v-card>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-card
                      flat
                      outlined
                      class="rounded-lg bg-slate-50 pa-3 h-100 border-slate"
                    >
                      <div
                        class="d-flex align-center justify-space-between mb-2 pb-2 custom-border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon small color="cyan darken-2" class="mr-2"
                            >mdi-map-marker-outline</v-icon
                          >
                          <span
                            class="font-size-14 font-weight-700 color-custom-blue"
                            >Address</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan darken-2"
                          class="bg-white custom-grey-border"
                          v-on:click="supplierAddressDialog = true"
                          title="Edit Address"
                          v-if="!purchaseOrderId"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>

                      <template v-if="activeAddress">
                        <div class="d-flex align-start font-size-13">
                          <v-icon small color="slate-500" class="mr-2 mt-1"
                            >mdi-map-marker-outline</v-icon
                          >
                          <span
                            class="font-weight-500 text-slate-700"
                            style="white-space: normal; word-break: break-word"
                            v-if="activeAddress.property_address"
                          >
                            {{ activeAddress.property_address }}
                          </span>
                          <em v-else class="text-muted font-italic"
                            >No address available</em
                          >
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex align-center py-2 red--text text--darken-1 font-size-13 font-weight-500"
                        >
                          <v-icon small color="red darken-1" class="mr-1"
                            >mdi-alert-circle-outline</v-icon
                          >
                          Please select Supplier
                        </div>
                      </template>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-card
                  flat
                  outlined
                  class="rounded-sm bg-slate-50 pa-3 border-slate"
                >
                  <div
                    class="d-flex align-center pb-2 mb-2 custom-border-bottom"
                  >
                    <v-icon color="cyan darken-2" small class="mr-2"
                      >mdi-information-outline</v-icon
                    >
                    <span class="font-weight-700 font-size-14 color-custom-blue"
                      >Purchase Order Details</span
                    >
                  </div>
                  <table class="width-100">
                    <tr>
                      <td
                        class="font-size-13 font-weight-500 py-2 text-slate-700"
                        width="220"
                      >
                        Purchase Order number
                      </td>
                      <td class="font-weight-700 font-size-14 py-2">
                        <v-skeleton-loader
                          v-if="pageLoading"
                          class="custom-skeleton"
                          type="text"
                        ></v-skeleton-loader>
                        <template v-else>
                          <span class="text-h5 font-weight-bold orange--text">{{
                            purchaseOrderCreate.barcode
                          }}</span>
                        </template>
                      </td>
                      <td class="font-size-13 py-2"></td>
                    </tr>
                    <tr>
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        Reference #
                      </td>
                      <td colspan="2" class="py-1">
                        <TextField
                          id="reference"
                          dense
                          filled
                          placeholder="Reference #"
                          solo
                          flat
                          counter="50"
                          v-model="purchaseOrderCreate.reference"
                          color="cyan"
                          :maxlength="50"
                        />
                        <v-text-field
                          v-if="false"
                          dense
                          color="cyan"
                          filled
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          v-model.trim="purchaseOrderCreate.reference"
                          placeholder="Reference #"
                          :rules="[
                            validateRules.minLength(
                              purchaseOrderCreate.reference,
                              'Reference #',
                              1
                            ),
                            validateRules.maxLength(
                              purchaseOrderCreate.reference,
                              'Reference #',
                              100
                            ),
                          ]"
                          :maxlength="100"
                          solo
                          flat
                          hide-details
                        ></v-text-field>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        Supplier Ref #
                      </td>
                      <td colspan="2" class="py-1">
                        <TextField
                          id="supplier_reference"
                          dense
                          filled
                          placeholder="Supplier Ref #"
                          solo
                          flat
                          counter="50"
                          v-model="purchaseOrderCreate.supplier_reference"
                          color="cyan"
                          :maxlength="50"
                        />
                        <v-text-field
                          v-if="false"
                          dense
                          color="cyan"
                          filled
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          v-model.trim="purchaseOrderCreate.supplier_reference"
                          placeholder="Supplier Ref #"
                          :rules="[
                            validateRules.minLength(
                              purchaseOrderCreate.supplier_reference,
                              'Supplier Ref #',
                              1
                            ),
                            validateRules.maxLength(
                              purchaseOrderCreate.supplier_reference,
                              'Supplier Ref #',
                              100
                            ),
                          ]"
                          :maxlength="100"
                          solo
                          flat
                          hide-details
                        ></v-text-field>
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2">
                        <label
                          class="required font-size-13 font-weight-500 text-slate-700"
                          >PO Date</label
                        >
                      </td>
                      <td colspan="2" class="py-1">
                        <DatePicker
                          :placeholder="'Date'"
                          solo
                          :pageLoading="pageLoading"
                          v-model="purchaseOrderCreate.date"
                          :defaultDate="purchaseOrderCreate.date"
                          :mandatory="true"
                          v-on:update:date-picker="setPODate"
                        ></DatePicker>
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2">
                        <label
                          class="required font-size-13 font-weight-500 text-slate-700"
                          >Expected Delivery Date</label
                        >
                      </td>
                      <td colspan="2" class="py-1">
                        <DatePicker
                          :placeholder="'Expected Delivery Date'"
                          solo
                          :pageLoading="pageLoading"
                          v-model="purchaseOrderCreate.expected_delivery_date"
                          :defaultDate="
                            purchaseOrderCreate.expected_delivery_date
                          "
                          :mandatory="true"
                          v-on:update:date-picker="setExpectedDate"
                        ></DatePicker>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        Category
                      </td>
                      <td colspan="2" class="py-1">
                        <v-autocomplete
                          :menu-props="{ offsetY: true }"
                          dense
                          filled
                          :items="poCategoryList"
                          item-color="cyan"
                          color="cyan"
                          placeholder="Category"
                          solo
                          flat
                          class="d-flex align-center"
                          v-model="purchaseOrderCreate.category"
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          item-value="text"
                          item-text="text"
                        >
                          <template v-slot:selection="{ item }">
                            <v-list-item-action class="ma-0">
                              <v-chip
                                style="height: 16px; width: 16px; padding: 0"
                                :color="item.color"
                              ></v-chip>
                            </v-list-item-action>
                            <v-list-item-content class="py-0">
                              <v-list-item-title class="text-capitalize">
                                {{ item.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-action class="mr-2">
                              <v-chip
                                style="height: 16px; width: 16px; padding: 0"
                                :color="item.color"
                              ></v-chip>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title class="text-capitalize">
                                {{ item.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action
                              v-if="item.quotation_linkage_mandatory === true"
                              class="ma-0 ml-2"
                            >
                              <v-chip
                                x-small
                                outlined
                                color="cyan darken-2"
                                class="font-weight-600 text-no-wrap"
                              >
                                Quotation required
                              </v-chip>
                            </v-list-item-action>
                          </template>
                          <template v-slot:no-data>
                            <v-list-item
                              ><v-list-item-title
                                >No Category(ies) Found.</v-list-item-title
                              ></v-list-item
                            >
                          </template>
                        </v-autocomplete>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        PIC
                      </td>
                      <td colspan="2" class="py-1">
                        <v-autocomplete
                          :menu-props="{ offsetY: true }"
                          dense
                          filled
                          :items="userList"
                          item-color="cyan"
                          color="cyan"
                          placeholder="PIC"
                          solo
                          flat
                          hide-details
                          class="d-flex align-center"
                          v-model.number="purchaseOrderCreate.pic"
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          item-value="id"
                          item-text="display_name"
                        >
                          <template v-slot:no-data>
                            <v-list-item
                              ><v-list-item-title
                                >No User(s) Found.</v-list-item-title
                              ></v-list-item
                            >
                          </template>
                        </v-autocomplete>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        Order By
                      </td>
                      <td colspan="2" class="py-1">
                        <v-autocomplete
                          :menu-props="{ offsetY: true }"
                          dense
                          filled
                          :items="userList"
                          item-color="cyan"
                          color="cyan"
                          placeholder="Order By"
                          solo
                          flat
                          hide-details
                          class="d-flex align-center"
                          v-model.number="purchaseOrderCreate.order_by"
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          item-value="id"
                          item-text="display_name"
                        >
                          <template v-slot:no-data>
                            <v-list-item
                              ><v-list-item-title
                                >No User(s) Found.</v-list-item-title
                              ></v-list-item
                            >
                          </template>
                        </v-autocomplete>
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2">
                        <label
                          class="required font-size-13 font-weight-500 text-slate-700"
                          >Payment Term</label
                        >
                      </td>
                      <td colspan="2" class="py-1">
                        <v-select
                          :menu-props="{ offsetY: true }"
                          dense
                          filled
                          :items="paymentTermList"
                          item-color="cyan"
                          color="cyan"
                          placeholder="Payment Term"
                          solo
                          flat
                          hide-details
                          class="d-flex align-center"
                          v-model.number="purchaseOrderCreate.payment_term"
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          append-outer-icon="mdi-cog"
                          @click:append-outer="addPaymentTermDialog"
                          item-value="id"
                          item-text="text"
                          :rules="[
                            validateRules.required(
                              purchaseOrderCreate.payment_term,
                              'Payment Term'
                            ),
                          ]"
                        >
                          <template v-slot:no-data>
                            <v-list-item
                              ><v-list-item-title
                                >No Payment Term(s) Found.</v-list-item-title
                              ></v-list-item
                            >
                          </template>
                        </v-select>
                      </td>
                    </tr>
                    <tr v-if="purchaseOrderCreate.payment_term == 5">
                      <td
                        class="py-2 font-size-13 font-weight-500 text-slate-700"
                      >
                        Due date
                      </td>
                      <td colspan="2" class="py-1">
                        <DatePicker
                          :placeholder="'Due date'"
                          solo
                          :pageLoading="pageLoading"
                          v-on:update:date-picker="setDueDate"
                        ></DatePicker>
                      </td>
                    </tr>
                  </table>
                </v-card>
              </v-col>
              <v-col md="12" v-if="getPermission('line-item:create')">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title
                    class="headline grey lighten-4"
                    @click="show_line_items = !show_line_items"
                  >
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      <v-icon>
                        {{
                          !show_line_items
                            ? "mdi-chevron-down"
                            : "mdi-chevron-up"
                        }}
                      </v-icon>

                      Line Items
                    </h3>
                  </v-card-title>

                  <v-expand-transition>
                    <v-card-text
                      v-show="show_line_items"
                      class="p-6 font-size-16"
                    >
                      <v-row dense>
                        <v-col cols="12" class="pt-0 pb-0">
                          <POLineItem
                            ref="purchaseOrderLineItems"
                            v-model="lineItem"
                            :isPurchaseOrder="true"
                            :unit="unit"
                            :productList="productList"
                            :gstvalue="purchaseOrderCreate.gstvalue"
                            :discountValue="purchaseOrderCreate.discount_value"
                            :discountValueType="
                              purchaseOrderCreate.discount_value_type
                            "
                            :supplier="purchaseOrderCreate.supplier?.id"
                            @update:total="handleLineItemCalculation"
                            @product-created="onProductCreated"
                            :related-detail="{ id: purchaseOrderId }"
                            :quotation-required="quotationLinkageMandatory"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
              <v-col md="12" class="px-0">
                <PurchaseOrderTermsConditions
                  :updateData="updateTermCondition"
                  :pageLoading="pageLoading"
                ></PurchaseOrderTermsConditions>
              </v-col>
              <v-col md="12" class="px-0">
                <PurchaseOrderDeliveryNoteRemark
                  :updateData="updateNotesAttachment"
                  :pageLoading="pageLoading"
                  @update="updatePurchaseOrderNotes"
                ></PurchaseOrderDeliveryNoteRemark>
              </v-col>
              <v-col md="12" class="px-0">
                <PurchaseOrderNotesAttachment
                  isPurchaseOrder
                  :updateData="updateNotesAttachment"
                  :pageLoading="pageLoading"
                ></PurchaseOrderNotesAttachment>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
      <template>
        <supplier-create
          :key="`supplier-create-${dialog_key}`"
          @supplier-created="handleNewSupplierCreated"
        />
      </template>
      <template v-if="refEntityId && refSupplierDialog">
        <RefSupplierDialog
          :entity="refEntityId"
          :dialog-width="900"
          :supplier-dialog="refSupplierDialog"
          v-on:closeDialog="refCloseDialog"
          v-on:resetAll="refResetAll"
          v-on:selectSupplier="refSelectSupplier"
        ></RefSupplierDialog>
      </template>
      <SupplierAddressSelect
        :dialog="supplierAddressDialog"
        :supplier-id="purchaseOrderCreate.supplier?.id"
        v-on:close="supplierAddressDialog = false"
        v-on:select="onSupplierAddressSelected"
      />
      <SupplierPersonSelect
        :dialog="supplierPersonDialog"
        :supplier-id="purchaseOrderCreate.supplier?.id"
        v-on:close="supplierPersonDialog = false"
        v-on:select="onSupplierPersonSelected"
      />
      <PaymentTermDialog
        :d-dialog="addPaymentDialog"
        :e_paymentTerm="paymentTermData"
        v-on:close-dialog="addPaymentDialog = false"
        v-on:payment-terms-updated="paymentTermsUpdated"
      ></PaymentTermDialog>
      <!-- <ManagePoCategory
        :c-dialog="poCategoryDialog"
        :category="poCategoryList"
        v-on:close-dialog="poCategoryDialog = false"
        v-on:get-po-categories="getOptions"
      ></ManagePoCategory> -->
    </template>
    <template v-slot:barcode-setting>
      <BarcodeSetting
        endpoint="purchase-order"
        :barcodeDialog="barcodeDialog"
        :dialogWidth="600"
        :barcodeSetting="barcodeSetting"
        v-on:update:barcode-setting="getOptions"
        v-on:close:barcode-dialog="barcodeDialog = false"
      ></BarcodeSetting>
    </template>
    <template> </template>
  </CreateUpdateTemplate>
</template>
<script>
import { mapGetters } from "vuex";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import BarcodeSetting from "@/view/pages/partials/Barcode-Setting.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CLEAR_ERROR,
  POST,
  PUT,
  GET,
  QUERY,
} from "@/core/services/store/request.module";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import POLineItem from "@/view/pages/partials/PO-Line-Item.vue";
import PurchaseOrderTermsConditions from "@/view/pages/partials/Terms-Conditions.vue";
import PurchaseOrderNotesAttachment from "@/view/pages/partials/Notes-Attachment.vue";
import PurchaseOrderDeliveryNoteRemark from "@/view/pages/purchase-order/Create-Or-Update/Delivery-Note-Remark.vue";
import { TermConditionEventBus } from "@/core/lib/term.condition.lib";
import { NoteAttachmentEventBus } from "@/core/lib/note.attachment.lib";
import {
  LineItemEventBus,
  LineItemCalculationEventBus,
} from "@/core/lib/line-item/line.item.lib";
import SupplierCreate from "@/view/components/SupplierCreateDialog.vue";
import { SET_CREATE_DIALOG_STATUS } from "@/core/services/store/supplier.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import RefSupplierDialog from "@/view/pages/partials/Select-Supplier.vue";
import PaymentTermDialog from "@/view/pages/partials/PaymentTermDialog.vue";
import TextField from "@/view/components/app-component/TextField.vue";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import SupplierAddressSelect from "@/view/components/SupplierAddressSelect.vue";
import SupplierPersonSelect from "@/view/components/SupplierPersonSelect.vue";
// import ManagePoCategory from "@/view/pages/partials/Manage-Po-Category.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "purchase-order-create",
  title: "Create Task",
  data() {
    return {
      purchaseOrderId: 0,
      purchaseOrderStatus: 0,
      supplierAddressDialog: false,
      show_line_items: false,
      supplierPersonDialog: false,
      selectedAddress: null,
      selectedPerson: null,
      title: null,
      description: null,
      productList: [],
      supplierProductRequestId: 0,
      unit: [],
      formLoading: false,
      purchaseOrderCreated: false,
      lineItemCreated: false,
      safeToLeave: false,
      refEntityId: 1,
      addPaymentDialog: false,
      paymentTermData: [],
      e_paymentTerm: [],
      dialog_key: Number(new Date()),
      disableItem: true,
      pageLoading: false,
      barcodeDialog: false,
      refCustomerPropertyDialog: false,
      refSupplierDialog: false,
      customerBillingDialog: false,
      customerPropertyDialog: false,
      customerPersonDialog: false,

      customer: {},
      customerId: 0,
      refCustomerId: 0,
      refPropertyId: 0,
      purchaseOrderDuplicate: 0,
      updateNotesAttachment: new Object(),
      updateTermCondition: new Object(),
      projectList: new Array(),
      supplierList: [],
      userList: [],
      poCategoryList: [],
      poCategoryDialog: false,
      paymentTermList: [],
      notesAttachment: null,
      termCondition: null,
      lineItem: [],
      lineItemCalculation: null,
      invalidLineItemAllocation: false,
      barcodeSetting: new Object(),
      purchaseOrder: 0,
      purchaseOrderLineItems: new Array(),
      purchaseOrderCreate: new Object({
        id: null,
        supplier: null,
        customer: null,
        barcode: null,
        reference: null,
        supplier_reference: null,
        date: new Date().toISOString().split("T")[0],
        project: null,
        expected_delivery_date: new Date().toISOString().split("T")[0],
        due_date: null,
        payment_term: null,
        pic: null,
        order_by: null,
        category: null,
        admin_remark: null,
        documents: [],
        term_conditions: null,
        additional_remarks: null,
        discount_type: null,
        discount_value_type: null,
        discount_value: null,
        adjustment: null,
        tax_active: false,
      }),
    };
  },
  components: {
    DatePicker,
    BarcodeSetting,
    CreateUpdateTemplate,
    PurchaseOrderTermsConditions,
    PurchaseOrderNotesAttachment,
    PurchaseOrderDeliveryNoteRemark,
    POLineItem,
    SupplierCreate,
    RefSupplierDialog,
    PaymentTermDialog,
    TextField,
    TextAreaField,
    SupplierAddressSelect,
    SupplierPersonSelect,
    // ManagePoCategory,
  },
  methods: {
    updatePurchaseOrderNotes(notes) {
      this.notesAttachment = Object.assign(
        {},
        this.notesAttachment || {},
        notes
      );
    },

    onProductCreated(product) {
      if (!product) return;
      const exists = this.productList.some((p) => p.id === product.id);
      if (!exists) {
        this.productList.push(product);
      }
    },
    onSupplierAddressSelected(row) {
      this.selectedAddress = row;
    },
    onSupplierPersonSelected(row) {
      this.selectedPerson = row;
    },
    addPOCategoryDialog() {
      this.poCategoryDialog = true;
    },
    addPaymentTermDialog() {
      this.paymentTermData = this.paymentTermList;
      this.addPaymentDialog = true;
    },
    paymentTermsUpdated(terms) {
      if (!Array.isArray(terms) || !terms.length) return;
      terms.forEach((term) => {
        if (!this.paymentTermList.some((item) => item.id === term.id)) {
          this.paymentTermList.push(term);
        }
      });
      this.purchaseOrderCreate.payment_term = terms[terms.length - 1].id;
    },
    setPODate(param) {
      this.purchaseOrderCreate.date = param;
    },
    setExpectedDate(param) {
      this.purchaseOrderCreate.expected_delivery_date = param;
    },
    setDueDate(param) {
      this.purchaseOrderCreate.due_date = param;
    },
    handleLineItemCalculation(calc) {
      if (!calc) return;
      this.invalidLineItemAllocation = Boolean(calc.allocationInvalid);
      if (Array.isArray(calc["line-item"])) {
        this.lineItem = calc["line-item"];
      }
      this.lineItemCalculation = calc.calculation
        ? {
            ...calc.calculation,
          }
        : {
            discount_type:
              calc.discount_type ??
              this.lineItemCalculation?.discount_type ??
              null,
            discount_value:
              calc.discount_value ??
              this.lineItemCalculation?.discount_value ??
              null,
            discount_value_type:
              calc.discount_value_type ??
              this.lineItemCalculation?.discount_value_type ??
              null,
            adjustment:
              calc.adjustment ?? this.lineItemCalculation?.adjustment ?? null,
            adjustment_amount:
              calc.adjustment_amount ??
              this.lineItemCalculation?.adjustment_amount ??
              null,
            tax_active:
              calc.tax_active ?? this.lineItemCalculation?.tax_active ?? null,
            discount_amount:
              calc.discount_amount ??
              this.lineItemCalculation?.discount_amount ??
              null,
            sub_total:
              calc.sub_total ?? this.lineItemCalculation?.sub_total ?? 0,
            total: calc.total ?? this.lineItemCalculation?.total ?? 0,
            tax_amount:
              calc.tax_amount ?? this.lineItemCalculation?.tax_amount ?? 0,
          };
    },
    createSupplierDialog() {
      this.dialog_key = Number(new Date());
      this.$nextTick(() => {
        this.$store.dispatch(SET_CREATE_DIALOG_STATUS, true);
      });
    },
    async handleNewSupplierCreated(supplierData) {
      const _this = this;
      const newSupplierId = supplierData?.id;
      if (!newSupplierId) return;

      try {
        const { data } = await _this.$store.dispatch(QUERY, {
          url: "supplier-list",
        });
        _this.supplierList = data || _this.supplierList;
        const fullSupplier =
          (data || []).find((item) => item.id === newSupplierId) ||
          supplierData;
        _this.refSelectSupplier(fullSupplier);
      } catch (error) {
        _this.logError(error);
        _this.refSelectSupplier(supplierData);
      }
    },
    refSelectSupplier(param) {
      const supplier =
        typeof param === "object" && param !== null
          ? param
          : this.supplierList.find((item) => item.id === param) || null;
      const previousSupplierId = Number(
        this.purchaseOrderCreate.supplier?.id || 0
      );
      const newSupplierId = Number(supplier?.id || 0);
      const supplierChanged = previousSupplierId !== newSupplierId;

      this.customer = supplier || {};
      this.customerId = supplier?.id || 0;
      this.refCustomerId = supplier?.id || 0;
      this.purchaseOrderCreate.supplier = supplier;
      if (!this.purchaseOrderId) {
        this.syncTaxWithSupplier(supplier);
      }
      this.selectedAddress = null;
      this.selectedPerson = null;

      if (supplierChanged) {
        this.lineItem = [];
        this.purchaseOrderLineItems = [];
        this.lineItemCalculation = null;
      }

      if (supplier && supplier.id) {
        this.getSupplierProducts();
      } else {
        this.productList = [];
      }
      this.$nextTick(() => {
        this.refSupplierDialog = false;
      });
    },
    refCloseDialog() {
      this.refSupplierDialog = false;
      this.refCustomerPropertyDialog = false;
    },
    refDialogOpen() {
      if (!this.quotationId) {
        this.refSupplierDialog = true;
      }
    },
    syncTaxWithSupplier(supplier) {
      const taxActive = supplier?.gst_registered === true;

      this.purchaseOrderCreate.tax_active = taxActive;

      this.$nextTick(() => {
        const lineItemComponent = this.$refs.purchaseOrderLineItems;
        if (!lineItemComponent) return;

        lineItemComponent.tax_active = taxActive;
        lineItemComponent.calculate_total();
      });
    },
    refResetAll() {
      this.refEntityId = 1;
      this.refSupplierDialog = false;
      this.refCustomerPropertyDialog = false;
      this.refCustomerId = 0;
    },
    getOptions(param) {
      const _this = this;
      const optionParams = { ..._this.$route.query, ...param };
      delete optionParams.supplier;
      delete optionParams.products_only;
      _this.pageLoading = true;
      return _this.$store
        .dispatch(QUERY, {
          url: "purchase-order/options",
          data: optionParams,
        })
        .then(({ data }) => {
          if (data.project) {
            _this.purchaseOrderCreate.project =
              data.project.id ?? _this.purchaseOrderCreate.project;
            if (data.project.reference != null) {
              _this.purchaseOrderCreate.supplier_reference =
                data.project.reference;
            }
            if (data.project.soled_job_no != null) {
              _this.purchaseOrderCreate.reference = data.project.soled_job_no;
            }
          }
          _this.unit = data.unit || [];
          _this.projectList = data.projects;
          _this.barcodeSetting = data.barcode_setting;
          _this.purchaseOrderCreate.gst = data.gst;
          _this.purchaseOrderCreate.gstvalue = data.gstvalue;
          _this.purchaseOrderCreate.barcode = data.barcode;
          _this.supplierList = data.supplier;
          _this.userList = data.users || [];
          _this.poCategoryList = data.po_categories || [];
          _this.paymentTermList = data.payment_term;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getSupplierProducts() {
      const _this = this;
      const supplierId = Number(_this.purchaseOrderCreate.supplier?.id || 0);
      const requestId = ++_this.supplierProductRequestId;

      _this.productList = [];
      if (!supplierId) {
        return Promise.resolve([]);
      }

      _this.pageLoading = true;
      return _this.$store
        .dispatch(QUERY, {
          url:
            "purchase-order/options?supplier=" +
            supplierId +
            "&products_only=1",
        })
        .then(({ data }) => {
          const activeSupplierId = Number(
            _this.purchaseOrderCreate.supplier?.id || 0
          );
          if (
            requestId === _this.supplierProductRequestId &&
            supplierId === activeSupplierId
          ) {
            _this.productList = data.products || [];
          }
          return _this.productList;
        })
        .catch((error) => {
          if (requestId === _this.supplierProductRequestId) {
            _this.logError(error);
          }
          return [];
        })
        .finally(() => {
          if (requestId === _this.supplierProductRequestId) {
            _this.pageLoading = false;
          }
        });
    },
    async updateOrCreate(action) {
      const _this = this;

      if (_this.isPurchaseOrderApproved) {
        return false;
      }

      // 1. Validate form
      if (!_this.$refs.purchaseOrderForm.validate()) {
        return false;
      }

      if (!_this.hasSelectedSupplier) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please select a Supplier before saving.")
        );
        return false;
      }

      if (
        !_this.purchaseOrderCreate.title ||
        !_this.purchaseOrderCreate.title.toString().trim()
      ) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please enter a Title before saving.")
        );
        return false;
      }

      if (!_this.purchaseOrderCreate.payment_term) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please select a Payment Term before saving.")
        );
        return false;
      }

      const emptySpecialLineItem = (
        Array.isArray(_this.lineItem) ? _this.lineItem : []
      ).find((row) => {
        const isHeader = row.type === "header" || row.product_type === "header";
        const isOther = row.type === "other" || row.product_type === "other";
        const lineItemText = String(
          row.product || row.product_name || ""
        ).trim();

        return (isHeader || isOther) && !lineItemText;
      });

      if (emptySpecialLineItem) {
        const isHeader =
          emptySpecialLineItem.type === "header" ||
          emptySpecialLineItem.product_type === "header";
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            isHeader
              ? "Please enter a Header Title before saving."
              : "Please enter an Other line item description before saving."
          )
        );
        return false;
      }

      if (!_this.hasCompleteLineItems) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            "Complete or remove every empty line item before saving."
          )
        );
        return false;
      }
      // Validate quotation linkage for selected PO category
      if (_this.quotationLinkageMandatory) {
        const lineItemsWithoutQuotation = _this.lineItem.filter((row) => {
          const isHeader =
            row.type === "header" || row.product_type === "header";

          const isOther = row.type === "other" || row.product_type === "other";

          if (isHeader || isOther) {
            return false;
          }

          return !(Number(row.quotation_id) > 0);
        });

        if (lineItemsWithoutQuotation.length > 0) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError(
              "Quotation required for each line item for the selected PO Category."
            )
          );
          return false;
        }
      }

      // 3. Reset state so each Save click is a clean attempt
      _this.purchaseOrderCreated = false;
      _this.lineItemCreated = false;
      _this.formLoading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});

      try {
        // prepare calculation payload (fallback values)
        const calculation = _this.lineItemCalculation || {
          discount_type: 1,
          discount_value: 0,
          deposit_value_type: 1,
          deposit_value: null,
          tax_active: 0,
          adjustment: 0,
          show_price: false,
          discount_level: "transaction",
          tax_value: 0,
          tax_amount: 0,
          sub_total: 0,
          total: 0,
        };
        const discountLevelType =
          calculation.discount_level === "line_item"
            ? 2
            : calculation.discount_level === "transaction"
            ? 1
            : Number(_this.purchaseOrderCreate.discount_type) || 1;
        const discountValueType =
          Number(
            calculation.discount_value_type ??
              calculation.discountValueType ??
              calculation.discount_type ??
              _this.purchaseOrderCreate.discount_value_type
          ) || 1;
        const transactionDiscountValue =
          calculation.discount_level === "transaction"
            ? Number(
                calculation.discount_value ??
                  calculation.discountValue ??
                  _this.purchaseOrderCreate.discount_value
              ) || 0
            : 0;

        const lineItems = Array.isArray(_this.lineItem) ? _this.lineItem : [];
        const purchaseOrderLineItems = lineItems.map((row) => {
          const rawProductId =
            row.product_id ||
            (typeof row.product === "object" ? row.product?.id : row.product) ||
            row.selected_product?.id;
          const productId = Number(rawProductId) || null;
          const productType =
            row.product_type ||
            (row.type === "header" || row.type === "other"
              ? row.type
              : "goods");

          return {
            id: row.id || null,
            order: row.order,
            index: row.index,
            uuid: row.uuid || null,
            product:
              row.product ||
              row.product_name ||
              row.name ||
              row.main_product?.name ||
              null,
            product_id: productId,
            status: true,
            description: row.description || null,
            quantity: Number(row.quantity) || 1,
            uom: row.uom || null,
            rate: Number(row.rate) || 0,
            total: Number(row.total) || 0,
            discount: row.discount || 0,
            discount_value: row.discount_value || 0,
            discount_type: row.discount_type || 1,
            type: row.type || "product",
            is_child: row.is_child || false,
            parent_uuid: row.parent_uuid || null,
            product_type: productType,
            po_type: row.po_type || null,
            quotation_id: Number(row.quotation_id || row.quotation) || null,
            visit_allocations: (Array.isArray(row.allocations)
              ? row.allocations
              : Array.isArray(row.visit_allocations)
              ? row.visit_allocations
              : []
            )
              .filter((allocation) => {
                const visitId = allocation.visit_id || allocation.id;
                const quantity = allocation.quantity || allocation.allocated;
                return (
                  !allocation.isWarehouse &&
                  Number(visitId) > 0 &&
                  Number(quantity) > 0
                );
              })
              .map((allocation) => ({
                visit_id: Number(allocation.visit_id || allocation.id),
                quantity: Number(allocation.quantity || allocation.allocated),
              })),
          };
        });

        const formData = {
          action,
          supplier: _this.purchaseOrderCreate.supplier.id,
          customer: 0,
          reference_no: _this.purchaseOrderCreate.reference,
          project: _this.purchaseOrderCreate.project,
          supplier_reference: _this.purchaseOrderCreate.supplier_reference,
          date: _this.purchaseOrderCreate.date,
          expected_delivery_date:
            _this.purchaseOrderCreate.expected_delivery_date,
          delivery_date: _this.purchaseOrderCreate.expected_delivery_date,
          barcode: _this.purchaseOrderCreate.barcode,
          due_date: _this.purchaseOrderCreate.due_date,
          pic: _this.purchaseOrderCreate.pic,
          order_by: _this.purchaseOrderCreate.order_by,
          category: _this.purchaseOrderCreate.category,
          payment_term: _this.purchaseOrderCreate.payment_term,
          admin_remark:
            _this.lodash.isEmpty(_this.notesAttachment) === false
              ? _this.notesAttachment.admin_notes
              : null,
          delivery_note:
            _this.lodash.isEmpty(_this.notesAttachment) === false
              ? _this.notesAttachment.delivery_note
              : null,
          remark:
            _this.lodash.isEmpty(_this.notesAttachment) === false
              ? _this.notesAttachment.remark
              : null,
          documents:
            _this.lodash.isEmpty(_this.notesAttachment) === false
              ? _this.notesAttachment.documents
              : [],
          term_conditions: _this.termCondition,
          additional_remarks:
            _this.lodash.isEmpty(_this.notesAttachment) === false
              ? _this.notesAttachment.additional_remarks
              : null,
          discount_type: discountLevelType,
          discount_value_type: discountValueType,
          discount_value: transactionDiscountValue,
          adjustment:
            _this.lodash.isEmpty(_this.lineItemCalculation) === false
              ? _this.lineItemCalculation.adjustment ||
                _this.lineItemCalculation.adjustmentAmount
              : null,
          "line-item": purchaseOrderLineItems,
          title: _this.purchaseOrderCreate.title,
          description: _this.purchaseOrderCreate.description,
          calculation,
          property_person: _this.activePerson?.id || null,
          billing_person: _this.activePerson?.id || null,
          property: _this.activeAddress?.id || null,
        };
        try {
          const isUpdate = _this.purchaseOrderId > 0;
          const requestType = isUpdate ? PUT : POST;
          const requestUrl = isUpdate
            ? `purchase-order/${_this.purchaseOrderId}`
            : "purchase-order";

          const purchaseOrderResponse = await _this.$store.dispatch(
            requestType,
            {
              url: requestUrl,
              data: formData,
            }
          );
          _this.purchaseOrder = isUpdate
            ? _this.purchaseOrderId
            : _this.lodash.toSafeInteger(purchaseOrderResponse.data.id);
          _this.purchaseOrderCreated = Boolean(_this.purchaseOrder);
          if (_this.purchaseOrderCreated) {
            _this.safeToLeave = true;
            _this.$router.push(
              _this.getDefaultRoute("purchase.order.detail", {
                params: { id: _this.purchaseOrder },
              })
            );
            return;
          }
        } catch (error) {
          _this.logError(error);
          ErrorEventBus.$emit(
            "update:error",
            InitializeError(
              `Purchase Order could not be ${
                _this.purchaseOrderId > 0 ? "updated" : "created"
              }. Please try again.`
            )
          );
          return;
        }
      } catch (error) {
        ErrorEventBus.$emit("update:error", InitializeError(error.toString()));
      } finally {
        _this.formLoading = false;
      }
    },
    getPurchaseOrder(purchaseOrder) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, { url: "purchase-order/" + purchaseOrder })
        .then(async ({ data }) => {
          _this.purchaseOrderCreate.id = data.id || purchaseOrder;
          _this.purchaseOrderStatus = _this.lodash.toSafeInteger(data.status);
          _this.purchaseOrderCreate.supplier =
            _this.lodash.isEmpty(data.supplier) === false
              ? data.supplier
              : null;
          if (_this.purchaseOrderCreate.supplier) {
            _this.customer = _this.purchaseOrderCreate.supplier;
            _this.customerId = _this.purchaseOrderCreate.supplier.id;
            _this.refCustomerId = _this.purchaseOrderCreate.supplier.id;
          }
          _this.purchaseOrderCreate.title = data.title || null;
          _this.purchaseOrderCreate.description = data.description || null;
          _this.purchaseOrderCreate.barcode = data.barcode || null;
          _this.purchaseOrderCreate.reference =
            data.reference_no || data.reference || null;
          _this.purchaseOrderCreate.supplier_reference =
            data.supplier_reference || null;
          _this.purchaseOrderCreate.date = data.date || null;
          _this.purchaseOrderCreate.expected_delivery_date =
            data.delivery_date || data.expected_delivery_date || null;
          _this.purchaseOrderCreate.due_date = data.due_date || null;
          _this.purchaseOrderCreate.gst =
            data.gst ?? _this.purchaseOrderCreate.gst;
          _this.purchaseOrderCreate.gstvalue =
            data.tax_value ??
            data.gstvalue ??
            data.gst ??
            _this.purchaseOrderCreate.gstvalue;
          _this.purchaseOrderCreate.tax_active =
            data.tax_active === "1" ||
            data.tax_active === 1 ||
            data.tax_active === true ||
            data.tax_applied === "1" ||
            data.tax_applied === 1 ||
            data.tax_applied === true;
          _this.purchaseOrderCreate.discount_value =
            Number(data.discount_value) || 0;
          _this.purchaseOrderCreate.discount_value_type =
            Number(data.discount_value_type) || 1;
          _this.purchaseOrderCreate.discount_type =
            Number(data.discount_type) || 1;
          _this.purchaseOrderCreate.adjustment = Number(data.adjustment) || 0;
          _this.purchaseOrderCreate.pic =
            Number(data.pic) || data.pic_user?.id || null;
          _this.purchaseOrderCreate.order_by =
            Number(data.order_by) || data.order_by_user?.id || null;
          _this.purchaseOrderCreate.category = data.category || null;
          _this.purchaseOrderCreate.payment_term =
            _this.lodash.isEmpty(data.payment_term) === false
              ? data.payment_term.id || data.payment_term
              : null;

          if (
            _this.purchaseOrderCreate.supplier &&
            _this.purchaseOrderCreate.supplier.id
          ) {
            await _this.getSupplierProducts();
          }

          const lineItems = Array.isArray(data.line_items)
            ? data.line_items.map((item, index) => {
                const productId =
                  Number(item.product_id || item.product) || null;
                const matchedProduct = _this.productList.find(
                  (product) => String(product.id) === String(productId)
                );
                const productDetails =
                  item.products || item.original_product || null;
                const serializedValue =
                  item.isSerialized ??
                  item.is_serialized ??
                  productDetails?.isSerialized ??
                  productDetails?.is_serialized ??
                  0;
                const lineItemDiscountType = Number(
                  item.discount_value_type ?? item.discount_type
                );
                const productUnit =
                  productDetails?.unit || item.uom || item.unit || null;
                const productName =
                  matchedProduct?.text ||
                  matchedProduct?.name ||
                  productDetails?.name ||
                  item.title ||
                  item.product_name ||
                  item.product ||
                  null;
                const quotationId =
                  Number(item.quotation_id || item.quotation) || null;
                const isDuplicateMode = _this.purchaseOrderDuplicate > 0;
                const savedVisitAllocations = isDuplicateMode
                  ? []
                  : Array.isArray(item.visit_allocations)
                  ? item.visit_allocations.map((allocation) => ({
                      id: Number(allocation.visit_id),
                      visit_id: Number(allocation.visit_id),
                      barcode: allocation.barcode || null,
                      allocated: Number(allocation.quantity) || 0,
                      isWarehouse: false,
                    }))
                  : [];
                const allocationSummary = isDuplicateMode
                  ? ""
                  : savedVisitAllocations.length
                  ? `${savedVisitAllocations
                      .map(
                        (allocation) =>
                          allocation.barcode || `Visit ${allocation.id}`
                      )
                      .join(", ")} · ${savedVisitAllocations.reduce(
                      (total, allocation) => total + allocation.allocated,
                      0
                    )}/${Number(item.quantity) || 0}`
                  : "";
                return {
                  original_product:
                    item.original_product ||
                    item.products ||
                    item.product ||
                    null,
                  id: item.id || null,
                  quotation_id: isDuplicateMode ? null : quotationId,
                  quotation_barcode: isDuplicateMode
                    ? null
                    : item.quotation_barcode || null,
                  linked_quotation: isDuplicateMode
                    ? null
                    : item.quotation_barcode || null,
                  uuid: item.uuid || null,
                  product: productName,
                  product_id: productId,
                  selected_product:
                    matchedProduct ||
                    (productId
                      ? {
                          id: productId,
                          text: productName,
                          name: productName,
                          uom: productUnit,
                          rate: item.rate || 0,
                          product_type: item.product_type || "goods",
                        }
                      : null),
                  product_name: productName,
                  barcode:
                    item.barcode ||
                    productDetails?.barcode ||
                    matchedProduct?.barcode ||
                    null,
                  description: item.description || null,
                  quantity: item.quantity || 1,
                  uom: productUnit,
                  tax: item.tax || 0,
                  rate: item.rate || 0,
                  total: item.total || 0,
                  warranty_data: null,
                  warranty_start_date: null,
                  warranty_unique_id: null,
                  warranty_description: null,
                  minimum_rental: null,
                  maximum_rental: null,
                  order: item.order || index + 1,
                  isEditable: false,
                  type: item.item_type || "product",
                  product_type: item.product_type || "goods",
                  po_type: item.po_type || null,
                  allocations: savedVisitAllocations,
                  visit_allocations: savedVisitAllocations,
                  allocation_summary: allocationSummary,
                  isSerialized:
                    serializedValue === true || Number(serializedValue) === 1
                      ? 1
                      : 0,
                  discount: item.discount ?? 0,
                  discount_value: item.discount_value ?? 0,
                  discount_type: [1, 2].includes(lineItemDiscountType)
                    ? lineItemDiscountType
                    : 1,
                };
              })
            : [];

          _this.lineItem = lineItems;

          _this.$nextTick(() => {
            const lineItemComponent = _this.$refs.purchaseOrderLineItems;
            if (!lineItemComponent) return;

            lineItemComponent.discount_level =
              Number(data.discount_type) === 2 ? "line_item" : "transaction";
            lineItemComponent.discount_value = Number(data.discount_value) || 0;
            lineItemComponent.discount_type =
              Number(data.discount_value_type) || 1;
            lineItemComponent.tax_active =
              data.tax_active === "1" ||
              data.tax_active === 1 ||
              data.tax_active === true ||
              data.tax_applied === "1" ||
              data.tax_applied === 1 ||
              data.tax_applied === true;
            lineItemComponent.gst_value =
              Number(data.tax_value ?? data.gstvalue ?? data.gst) || 0;
            lineItemComponent.adjustment = Number(data.adjustment) || 0;
            lineItemComponent.calculate_total();
          });

          _this.lineItemCalculation = {
            additional_remarks: data.additional_remarks,
            sub_total: data.sub_total,
            tax_amount: data.tax_amount,
            discount_amount: data.discount_amount,
            discount_value: data.discount_value,
            discount_type: data.discount_type,
            discount_value_type: data.discount_value_type,
            adjustment: data.adjustment,
            total: data.total,
          };

          _this.updateNotesAttachment = {
            admin_remark: data.admin_remark,
            delivery_note: data.delivery_note,
            remark: data.remark,
            client_remark: null,
            notify_admin: 0,
            notify_customer: 0,
            notify_engineer: 0,
            documents: data.documents || [],
          };

          _this.updateTermCondition = { term_conditions: data.term_conditions };
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {},
  mounted() {
    const _this = this;
    _this.getOptions();
    const isUpdate = _this.purchaseOrderId > 0;
    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Purchase Order", route: "purchase.order" },
      { title: isUpdate ? "Update" : "Create" },
    ]);

    NoteAttachmentEventBus.$on("update:notes-attachment", (argument) => {
      const attachmentNotes = _this.lodash.omit(argument || {}, [
        "delivery_note",
        "remark",
      ]);
      _this.notesAttachment = Object.assign(
        {},
        _this.notesAttachment || {},
        attachmentNotes
      );
    });
    TermConditionEventBus.$on("update:term-condition", (argument) => {
      _this.termCondition = argument;
    });
    LineItemEventBus.$on("update:line-item", (argument) => {
      _this.lineItem = argument;
    });
    LineItemCalculationEventBus.$on(
      "update:line-item-calculation",
      (argument) => {
        _this.lineItemCalculation = argument;
      }
    );
  },
  created() {
    const _this = this;
    _this.purchaseOrderId = _this.lodash.toSafeInteger(_this.$route.params.id);
    _this.purchaseOrderDuplicate = _this.lodash.toSafeInteger(
      _this.$route.query.duplicate
    );
    if (_this.purchaseOrderId > 0) {
      _this.getPurchaseOrder(_this.purchaseOrderId);
    } else if (_this.purchaseOrderDuplicate > 0) {
      _this.getPurchaseOrder(_this.purchaseOrderDuplicate);
    }
  },
  computed: {
    ...mapGetters([
      "vCustomer",
      "vBilling",
      "vBillingContact",
      "vPropertyContact",
      "vProperty",
    ]),
    quotationLinkageMandatory() {
      const selectedCategory = this.poCategoryList.find(
        (category) =>
          String(category.text) === String(this.purchaseOrderCreate.category)
      );

      const mandatory = selectedCategory?.quotation_linkage_mandatory;
      return (
        mandatory === true ||
        mandatory === 1 ||
        mandatory === "1" ||
        mandatory === "true"
      );
    },
    hasRequiredQuotationLinks() {
      if (!this.quotationLinkageMandatory) {
        return true;
      }

      return (this.lineItem || []).every((row) => {
        const isHeader = row.type === "header" || row.product_type === "header";
        const isOther = row.type === "other" || row.product_type === "other";

        return isHeader || isOther || Number(row.quotation_id) > 0;
      });
    },
    activePerson() {
      return (
        this.selectedPerson ||
        this.purchaseOrderCreate.supplier?.default_person ||
        null
      );
    },
    activeAddress() {
      return (
        this.selectedAddress ||
        this.purchaseOrderCreate.supplier?.address?.[0] ||
        null
      );
    },
    hasSelectedSupplier() {
      return (
        this.purchaseOrderCreate.supplier &&
        this.purchaseOrderCreate.supplier.id
      );
    },
    hasCompleteLineItems() {
      return (
        Array.isArray(this.lineItem) &&
        this.lineItem.length > 0 &&
        this.lineItem.every((row) => {
          const isHeader =
            row.type === "header" || row.product_type === "header";
          const isOther = row.type === "other" || row.product_type === "other";
          if (isHeader) {
            return true;
          }
          if (isOther) {
            return true;
          }

          return Boolean(row.product || row.product_name);
        })
      );
    },
    isPurchaseOrderActionEnabled() {
      return (
        this.hasSelectedSupplier &&
        this.purchaseOrderCreate.title &&
        this.purchaseOrderCreate.title.toString().trim().length > 0 &&
        this.purchaseOrderCreate.date &&
        this.purchaseOrderCreate.expected_delivery_date &&
        this.purchaseOrderCreate.payment_term &&
        this.hasCompleteLineItems &&
        this.hasRequiredQuotationLinks
      );
    },
    isPurchaseOrderApproved() {
      return this.purchaseOrderId > 0 && this.purchaseOrderStatus !== 1;
    },
    defaultStartDate() {
      if (this.purchaseOrderCreate.start_date)
        return this.purchaseOrderCreate.start_date;
      return new Date().toISOString().substr(0, 10);
    },
    defaultDueDate() {
      if (this.purchaseOrderCreate.due_date)
        return this.purchaseOrderCreate.due_date;
      let today = new Date();
      today.setDate(today.getDate() + 30);
      return today.toISOString().substr(0, 10);
    },
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.safeToLeave) {
      _this.safeToLeave = false;
      next();
      return;
    }
    _this.routePreventDialog = true;
    PreventDialogEventBus.$on("stay-on-page", function () {
      _this.routePreventDialog = false;
      next(false);
    });
    PreventDialogEventBus.$on("leave-page", function () {
      _this.routePreventDialog = false;
      next();
    });
  },
};
</script>
<style scoped>
.perfect-scroll-create-container {
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}
</style>
